export default __webpack_public_path__ + "static/media/CNo.85-4.2af8e2fe.jpg";